import axios from 'axios';
import { API_URL } from '../config';
import { AxiosRequestConfig } from 'axios';
interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  permission?: string;
}

export const getCompanyAlerts = async (
  token: string,
  page: number,
  pageSize: number = 10,
  category: string,
  permission: string | null,
  signal?: AbortSignal,
  search?: string,
  hasAttachments?: boolean
) => {
  const response = await axios.get(`${API_URL}/presenze/company/alerts/`, {
    headers: {
      'Authorization': token,
    },
    params: {
      page,
      page_size: pageSize,
      category,
      ...(search?.trim() && {
        search: search.trim(),
      }),
      ...(typeof hasAttachments === 'boolean' && {
        has_attachments: hasAttachments,
      }),
    },
    permission,
    signal,
  } as CustomAxiosRequestConfig);

  return response.data;
};

export const postAlertCompany = async (token: string, data: any, files: File[] = []) => {
  const formData = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    if (value === null || value === undefined) return;

    if (Array.isArray(value)) {
      value.forEach((item) => {
        formData.append(key, String(item));
      });
    } else {
      formData.append(key, String(value));
    }
  });

  files.forEach((file) => {
    formData.append('files', file);
  });

  const response = await axios.post(
    `${API_URL}/presenze/company/alerts/`,
    formData,
    {
      headers: {
        'Authorization': token,
      }
    }
  );

  return response.data;
};


export const deleteAlertCompany = async (token: string, id: string) => {
  const response = await axios.delete(`${API_URL}/presenze/company/alerts/${id}/`, {
      headers: {
          'Authorization': `${token}`,
      },
  });
  return response.data;
};

export const getCompanyAlertsReadbyList = async (
  token: string, 
  id: string,
  page: number, 
  pageSize: number = 10, 
  permission: string | null
) => {
  const response = await axios.get(`${API_URL}/presenze/company/alerts/${id}/read-by/`, {
    headers: {
      'Authorization': token,
    },
    params: {
      page: page,
      page_size: pageSize,
    },
    permission,
  } as CustomAxiosRequestConfig);
  return response.data;
};
